/* ---- SAMPLE LIMIT: only on CART (page or drawer) ---- */
(function () {
  // Sadece /cart veya cart DOM’u varsa çalış
  function isCart() {
    return /\/cart(\/|$)/.test(location.pathname) ||
           document.querySelector('.cart__items, [data-cart], #CartDrawer, .cart-drawer');
  }
  if (!isCart()) return;

  var MAP = window.variantMaxQtyMap || {};
  function toInt(v, d){ v=parseInt(v,10); return isNaN(v) ? (d||0) : v; }

  // Satırdan variant ID’yi yakala (data-attr -> link -> hidden input)
  function getVid(row){
    if (!row) return null;
    var a = row.getAttribute('data-variant-id');
    if (a) return a;
    var link = row.querySelector('a[href*="variant="]')?.getAttribute('href');
    if (link) { var m = link.match(/variant=(\d+)/); if (m) return m[1]; }
    var hid = row.querySelector('input[name="id[]"], input[name="id"]');
    if (hid) return hid.value;
    return null;
  }

  function clampInput(input, max){
    var v = toInt(input.value, 0);
    if (v > max) input.value = max; // sessiz kısalt
  }

  function applyLimits(root){
    (root || document).querySelectorAll('li[id^="CartItem-"], .cart-item, [data-cart-item]').forEach(function(row){
      var vid = getVid(row);
      var max = MAP[vid];
      if (!max) return;

      var input =
        row.querySelector('input[type="number"][name^="updates"]') ||
        row.querySelector('input[type="number"][name="updates[]"]') ||
        row.querySelector('quantity-input input[type="number"]');

      if (!input) return;

      input.setAttribute('max', max);
      clampInput(input, max);

      var onChange = function(){ clampInput(input, max); };
      input.addEventListener('input', onChange);
      input.addEventListener('change', onChange);

      // Artı/eksi butonları
      row.querySelectorAll('button, a').forEach(function (el) {
        var txt = (el.className || '') + ' ' + (el.getAttribute('aria-label') || '');
        if (/\b(plus|minus|increment|decrement|quantity)\b/i.test(txt)) {
          el.addEventListener('click', function(){ setTimeout(onChange, 0); });
        }
      });
    });

    // Form gönderimde son kontrol
    var form = document.querySelector('form[action="/cart"], form[action*="/cart"]');
    if (form && !form.__maxHooked){
      form.__maxHooked = true;
      form.addEventListener('submit', function () {
        document.querySelectorAll('li[id^="CartItem-"], .cart-item, [data-cart-item]').forEach(function(row){
          var vid = getVid(row), max = MAP[vid];
          if (!max) return;
          var input = row.querySelector('input[type="number"][name^="updates"], input[type="number"][name="updates[]"]');
          if (input) clampInput(input, max);
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function(){ applyLimits(document); });

  // Drawer/AJAX için
  new MutationObserver(function(muts){
    muts.forEach(function(m){
      m.addedNodes && m.addedNodes.forEach(function(n){
        if (n.nodeType===1) applyLimits(n);
      });
    });
  }).observe(document.documentElement, {childList:true, subtree:true});
})();

/* ---- SAMPLE LIMIT: only on PRODUCT PAGE ---- */
(function () {
  // Sadece ürün sayfasında çalış
  if (!/\/products\//.test(location.pathname)) return;

  var MAP = window.variantMaxQtyMap || {};
  function toInt(v, d){ v=parseInt(v,10); return isNaN(v) ? (d||0) : v; }

  function qtyInputs() {
    return document.querySelectorAll(
      'quantity-input input[type="number"], ' + // Dawn
      'input[type="number"][name="quantity"], ' +
      'input[type="number"][id*="Quantity"]'
    );
  }

  function applyForVariant(vid){
    var max = MAP[vid];
    qtyInputs().forEach(function(input){
      if (max) {
        input.setAttribute('max', max);
        if (toInt(input.value, 1) > max) input.value = max; // sessiz kısalt
        var clamp = function(){
          var v = toInt(input.value, 1);
          if (v > max) input.value = max;
          if (v < 1) input.value = 1;
        };
        input.oninput = clamp;
        input.onchange = clamp;
      } else {
        // Limit yoksa kısıtlamaları kaldır
        input.removeAttribute('max');
        input.oninput = null;
        input.onchange = null;
      }
    });
  }

  function bind(){
    var idEl = document.querySelector('form[action*="/cart"] input[name="id"]');
    if (!idEl) return;

    // İlk yüklemede uygula
    applyForVariant(idEl.value);

    // Variant değişimini yakala
    idEl.addEventListener('change', function(){ applyForVariant(idEl.value); });

    // Bazı temalar value’yu JS ile güncelliyor → MutationObserver
    new MutationObserver(function(muts){
      muts.forEach(function(m){
        if (m.type === 'attributes' && m.target === idEl && m.attributeName === 'value') {
          applyForVariant(idEl.value);
        }
      });
    }).observe(idEl, { attributes:true, attributeFilter:['value'] });

    // Artı/eksi butonları için de tetikle
    document.querySelectorAll('quantity-input, .quantity, .product-form__quantity').forEach(function(box){
      box.addEventListener('click', function(){
        setTimeout(function(){ applyForVariant(idEl.value); }, 0);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bind);
  // Geç yüklenen temalar için küçük gecikmeli ikinci bağlayıcı
  setTimeout(bind, 500);
})();

